import styled from 'styled-components';
import React from 'react';
import ArticleDetailAuthor, {
  ArticleDetailAuthorVariantProps as ArticleMetaVariantProps,
  variantSize,
} from '../ArticleDetailAuthor';

export interface ArticleMetaProps extends ArticleMetaVariantProps {
  authorName?: string;
  authorImageUrl?: string;
  infos?: string[] | null;
  className?: string;
}

function ArticleMeta({
  authorName,
  authorImageUrl,
  size = 'medium',
  infos,
  className,
}: ArticleMetaProps) {
  return (
    <ArticleMetaCss className={className}>
      {(authorName || authorImageUrl) && (
        <ArticleDetailAuthor
          size={size}
          name={authorName}
          imageUrl={authorImageUrl}
        />
      )}
      {infos?.map((info, idx) => (
        <ArticleMetaInfoCss key={`article-meta-info-${idx}`} size={size}>
          {info}
        </ArticleMetaInfoCss>
      ))}
    </ArticleMetaCss>
  );
}

const ArticleMetaCss = styled.div`
  display: flex;
  align-items: center;

  & > div,
  span:not(:last-child) {
    margin-right: ${p => p.theme.sizes.spacing2};
  }
`;

const ArticleMetaInfoCss = styled.span<ArticleMetaVariantProps>`
  ${p => p.theme.getFontStyle('secondary', 'medium')}
  font-size: ${variantSize('typography', ['textXxxs', 'textXxs', 'textSm2'])};
  line-height: 1.8;
  color: ${p => p.theme.articleMeta.infoColor};
`;

export default ArticleMeta;
